module.exports = __webpack_public_path__ + "media/images/landing/we_believe_bg-460db6d73b0da7316a9a39003361f6eb.jpg";